"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeView = void 0;
const View_1 = require("../core/render/View");
const HeadingWidget_1 = require("./widgets/HeadingWidget");
const HtmlWidget_1 = require("./widgets/HtmlWidget");
const viewModelCollection_1 = require("../viewModelCollection");
class HomeView extends View_1.View {
    constructor() {
        super();
        this.dataContext = viewModelCollection_1.getHomeViewModel();
        this.dataContext.title = "Home";
        let mainElement = document.createElement("main");
        mainElement.classList.add("main", "main-home");
        this.renderBody = mainElement;
        let heading = new HeadingWidget_1.HeadingWidget(1, "Welcome to Mu-Meta-Morph!");
        heading.renderBody.classList.add("text-center");
        let subText = new HtmlWidget_1.HtmlWidget("p", "");
        subText.element.textContent = "The most flexible music player on the face of the planet!";
        subText.element.classList.add("text-center");
        let div = new HtmlWidget_1.HtmlWidget("div", "");
        div.element.classList.add("main-banner");
        div.widgets.push(heading);
        div.widgets.push(subText);
        let mainBody = new HtmlWidget_1.HtmlWidget("div", "");
        mainBody.element.classList.add("main-home-body");
        let statisticsGridItem = mainBody.createElement("div", div => {
            div.classList.add("main-home-body-grid-item");
        });
        statisticsGridItem.createHeading("System Statistics");
        statisticsGridItem.createElementAndAppend("table", (element) => __awaiter(this, void 0, void 0, function* () {
            let table = element;
            table.innerHTML = `
<thead>
<th>Statistic</th>
<th>Value</th>
</thead>
`;
            let body = table.createTBody();
            yield this.addRowAsync(body, "Number of Songs", () => __awaiter(this, void 0, void 0, function* () {
                let number = yield this.dataContext.getNumberOfSongs();
                return String(number);
            }));
            this.addRow(body, "Number of Plugins Loaded", () => String(this.dataContext.getNumberOfPlugins()));
        }));
        let quickSwitchGridItem = mainBody.createElement("div", div => {
            div.classList.add("main-home-body-grid-item");
        });
        quickSwitchGridItem.createHeading("Switch Songs Quickly");
        quickSwitchGridItem.createElement("table", (element) => __awaiter(this, void 0, void 0, function* () {
            let table = element;
            table.innerHTML = `
<thead>
<th>Name</th>
<th>Play</th>
</thead>
`;
            let body = table.createTBody();
            this.dataContext.getSongs().then(songs => {
                for (let song of songs) {
                    this.addSongToTable(body, song);
                }
            });
        }));
        this.widgets.push(div);
        this.widgets.push(mainBody);
    }
    addRowAsync(tableBody, name, value) {
        return __awaiter(this, void 0, void 0, function* () {
            let songRow = tableBody.insertRow();
            let nameCell = songRow.insertCell();
            nameCell.textContent = name;
            let valueCell = songRow.insertCell();
            valueCell.textContent = yield value();
        });
    }
    addRow(tableBody, name, value) {
        let songRow = tableBody.insertRow();
        let nameCell = songRow.insertCell();
        nameCell.textContent = name;
        let valueCell = songRow.insertCell();
        valueCell.textContent = value();
    }
    addSongToTable(tableBody, song) {
        let songRow = tableBody.insertRow();
        let nameCell = songRow.insertCell();
        nameCell.textContent = song.name;
        let playCell = songRow.insertCell();
        let playAnchor = document.createElement("a");
        playAnchor.href = "#";
        playAnchor.textContent = "Play";
        playAnchor.addEventListener("click", (evt) => __awaiter(this, void 0, void 0, function* () {
            evt.preventDefault();
            yield this.dataContext.switchSong(song.songId);
        }));
        playCell.appendChild(playAnchor);
    }
    ;
    shouldRender() {
        return true;
    }
}
exports.HomeView = HomeView;
//# sourceMappingURL=HomeView.js.map